import "./intro.scss";
// import {init} from 'ityped';
// import { useEffect, useRef } from "react";


export default function Intro(){
    // const textRef = useRef();

    // useEffect(() => {
    //     init(textRef.current, { 
    //         showCursor: false, 
    //         strings: ['Software Developer']
    //     });
    // }, []);

    return(
        <div className="intro" id="intro">
            <div className="left">
                <div className="imgContainer">
                    <img src="assets/ravinder_pic.jpg" alt="" />
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <h2>Hi There, I am</h2>
                    <h1>Ravinder</h1>
                    <h3>
                        Software Engineer 
                    </h3>
                    {/* <h4>
                        Skills: 
                        <span ref={textRef}></span>
                    </h4> */}
                </div>

                <a href="#skills">
                    <img src="assets/down.png" alt="" />
                </a>
            </div>
        </div>
    );
}